import { Chip, ChipProps } from "@mui/material";

/** Style charte graphique unifié pour les chips d'allergènes (warning = danger / vigilance) */
const allergenChipSx = {
  bgcolor: "white",
  color: "warning.dark",
  fontWeight: 600,
  border: "1px solid",
  borderColor: "warning.main",
};

export interface AllergenChipProps extends Omit<ChipProps, "size"> {
  /** Label affiché (ex: "Gluten", "🫘 Céleri") */
  label: React.ReactNode;
  /** Style compact (hauteur réduite, police plus petite) pour listes denses */
  compact?: boolean;
  /** Taille MUI : small par défaut pour cohérence */
  size?: "small" | "medium";
}

/**
 * Chip d'allergène avec charte graphique unifiée (rouge / warning) dans toute l'app.
 * Utilisé : fiche client, commande, ingrédients, référentiel allergènes.
 */
export function AllergenChip({
  label,
  compact = true,
  size = "small",
  sx,
  ...rest
}: AllergenChipProps): JSX.Element {
  return (
    <Chip
      size={size}
      label={label}
      sx={{
        ...allergenChipSx,
        ...(compact && { height: 20, fontSize: "10px" }),
        ...sx,
      }}
      {...rest}
    />
  );
}
